import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { pxToRem } from '../../utils/pxToRem';

const Path = (props: any) => <motion.path fill="transparent" strokeWidth="2.5" strokeLinecap="round" {...props} />;

export const MenuToggle = ({ toggle, isOpen }: { toggle: () => void; isOpen: boolean }) => (
    <motion.div initial={false} animate={isOpen ? 'open' : 'closed'}>
        <ToggleButton
            aria-label={isOpen ? 'Zamknij menu' : 'Otwórz menu'}
            aria-expanded={isOpen}
            onClick={toggle}
            className="btn-nav"
            $isOpen={isOpen}
        >
            <svg
                aria-hidden="true"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                style={{ marginLeft: '2px', marginTop: '2px' }}
            >
                <Path
                    variants={{
                        closed: { d: 'M 2 2.5 L 20 2.5', stroke: '#ffffff' },
                        open: { d: 'M 3 16.5 L 17 2.5', stroke: '#36355D' },
                    }}
                />
                <Path
                    d="M 2 9.423 L 20 9.423"
                    variants={{
                        closed: { opacity: 1, stroke: '#ffffff' },
                        open: { opacity: 0, stroke: '#36355D' },
                    }}
                    transition={{ duration: 0.1 }}
                />
                <Path
                    variants={{
                        closed: { d: 'M 2 16.346 L 20 16.346', stroke: '#ffffff' },
                        open: { d: 'M 3 2.5 L 17 16.346', stroke: '#36355D' },
                    }}
                />
            </svg>
        </ToggleButton>
    </motion.div>
);

const ToggleButton = styled.button<{ $isOpen: boolean }>`
    border: none;
    cursor: pointer;
    position: fixed;
    top: 4rem;
    right: 1rem;
    width: 2.75rem;
    height: 2.75rem;
    border-radius: 50%;
    background-color: ${(props) => (props.$isOpen ? '#ffffff' : 'var(--color-primary)')};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    padding: 0;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    transition: background-color 300ms ease;
`;
